<template id="bannerTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>

    <!-- Snackbar -->
    <div id="snackbar" class="snackbar alert">{{serverMessage}}</div>


    <div class="main-div" :class="formState.invalidShake ? 'invalid' : ''">
      <!-- Loading -->
      <div class="spinner-wrapper" v-bind:class="formState.loading ? 'show' : 'hide'">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading</span>
        </div>
      </div>

      <p class="alert alert-danger text-left" v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
      </p>
      <b-button block  class="btn btn-primary mb-4 p-5">Website Home Sections</b-button>

      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Home Sections Order</a>
          <a class="nav-item nav-link" id="nav-design-tab" data-toggle="tab" href="#nav-design" role="tab" aria-controls="nav-design" aria-selected="false">Design Your Thoob</a>
          <a class="nav-item nav-link" id="nav-banner-one-tab" data-toggle="tab" href="#nav-banner-one" role="tab" aria-controls="nav-banner-one" aria-selected="false">Home Banner 1</a>
          <a class="nav-item nav-link" id="nav-banner-two-tab" data-toggle="tab" href="#nav-banner-two" role="tab" aria-controls="nav-banner-two" aria-selected="false">Home Banner 2</a>
          <!-- <a class="nav-item nav-link" id="nav-why-ithoob-tab" data-toggle="tab" href="#nav-why-ithoob" role="tab" aria-controls="nav-why-ithoob" aria-selected="false">Why iThoob </a> -->
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <b-card no-body class="col-12 mb-1 p-0">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-new'"  variant="info"  class="btn btn-primary">Home Sections Order</b-button>
            </b-card-header>
            <b-card-body class="row text-left"> 
              <ul class="list-unstyled">
                <li class="media" v-for="(section, index) in sections" :key="index">
                  <div class="d-flex arrows">
                    <i class="fas fa-angle-up" v-on:click="handleUpClicked(index)"></i>
                    <i class="fas fa-angle-down" v-on:click="handleDownClicked(index)"></i>
                  </div>
                  <img class="mr-3" v-if="section.section_name == 'winter_collection'" src="https://assets.ithoob.com/uploads/product_image-1638967121218.jpg-normal.jpg" alt="Recommended" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'winter_collection'">
                    <h5 class="mt-0 mb-1">Winter Collection</h5>
                    Winter Collection Section in Home Page.
                  </div>

                  <img class="mr-3" v-if="section.section_name == 'perfume'" src="https://assets.ithoob.com/uploads/product_image-1615835040149.jpg-normal.jpg" alt="Recommended" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'perfume'">
                    <h5 class="mt-0 mb-1">Perfume Section</h5>
                    Perfume Section in Home Page.
                  </div>

                  <img class="mr-3" v-if="section.section_name == 'recommended_products'" src="https://assets.ithoob.com/uploads/product_image-1602871686141.jpg-normal.jpg" alt="Recommended" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'recommended_products'">
                    <h5 class="mt-0 mb-1">Recommended Products</h5>
                    Recommended Product Section in Home Page.
                  </div>

                  <img class="mr-3" v-if="section.section_name == 'latest_clothes'" src="https://assets.ithoob.com/uploads/product_image-1598521180903-normal.png" alt="Clothes" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'latest_clothes'">
                    <h5 class="mt-0 mb-1">Clothes</h5>
                    Latest Clothes Section In Home Page.
                  </div>

                  <img class="mr-3"  v-if="section.section_name == 'clothes_design'" src="https://assets.ithoob.com/uploads/product_image-1596577478905-normal.png" alt="Recommended" width="80px" height="80px">
                  <div class="media-body"  v-if="section.section_name == 'clothes_design'">
                    <h5 class="mt-0 mb-1">Clothes Design</h5>
                      The Section Which descripe The steps of Thoob Design.
                  </div>

                  <img class="mr-3" v-if="section.section_name == 'latest_accessories'" src="https://assets.ithoob.com/uploads/product_image-1611787742502.jpg-normal.jpg" alt="Accessories" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'latest_accessories'">
                    <h5 class="mt-0 mb-1">Accessories</h5>
                    Latest Accessories Section In Home Page
                  </div>

                  <img class="mr-3" v-if="section.section_name == 'latest_designs'" src="https://assets.ithoob.com/uploads/product_image-1607959817083.jpg-normal.jpg" alt="Accessories" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'latest_designs'">
                    <h5 class="mt-0 mb-1">Latest Designs</h5>
                    Latest designs Section in home Page.
                  </div>

                  <img class="mr-3" v-if="section.section_name == 'banner_one'"  src="https://assets.ithoob.com/uploads/images-1585668131371.jpg" alt="Accessories" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'banner_one'" >
                    <h5 class="mt-0 mb-1">First Banner</h5>
                    First Banner In home Page.
                  </div>

                  <img class="mr-3" v-if="section.section_name == 'latest_shoes'" src="https://assets.ithoob.com/uploads/product_image-1601479572803.jpg-normal.jpg" alt="Accessories" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'latest_shoes'">
                    <h5 class="mt-0 mb-1">Latest Shoes</h5>
                    Latest Shoes section In home Page.
                  </div>

                  <img class="mr-3" v-if="section.section_name == 'banner_two'" src="https://assets.ithoob.com/uploads/images-1585668131371.jpg" alt="Accessories" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'banner_two'">
                    <h5 class="mt-0 mb-1">Second Banner</h5>
                    Second Banner In home Page.
                  </div>

                  <img class="mr-3" v-if="section.section_name == 'why_iThoob'" src="https://assets.ithoob.com/uploads/images-1585668151195.jpg" alt="Accessories" width="80px" height="80px">
                  <div class="media-body" v-if="section.section_name == 'why_iThoob'">
                    <h5 class="mt-0 mb-1">Why iThoob</h5>
                    Why iThoob section In home Page.
                  </div>
                  <label>
                      Show the Section
                    <input type="checkbox" v-model="section.isVisiable" :checked="section.isVisiable">
                    </label>
                </li>
              </ul>
            </b-card-body>
              <button
                :disabled="formState.loading"
                type="button"
                v-on:click="updateHomeSections('sectionsOrder')"
                class="btn btn-primary"
              >Save Changes</button>
          </b-card>
        </div>
        <div class="tab-pane fade" id="nav-design" role="tabpanel" aria-labelledby="nav-design-tab">
          <b-card no-body class="col-12 mb-1 p-0">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-new'"  variant="info"  class="btn btn-primary">Design Your Thoob Steps</b-button>
            </b-card-header>
              <b-card-body class="row text-left"> 
                <!-- Title -->
                <div class="form-group col-sm-6">
                  <label for="title">Title</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="firstSection.title"
                    id="title"
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="title_en">Title (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="firstSection.title_en"
                    id="title_en"
                  />
                </div>

                <!-- Content/Description -->
                <div class="form-group col-sm-6">
                  <label for="content">Description</label>
                  <textarea
                    class="form-control"
                    id="content"
                    cols="30"
                    rows="3"
                    v-model="firstSection.content"
                    >
                  </textarea>
                </div>
                <div class="form-group col-sm-6">
                  <label for="content_en">Description (EN)</label>
                  <textarea
                    class="form-control"
                    id="content_en" 
                    cols="30"
                    rows="3"
                    v-model="firstSection.content_en"
                    >
                  </textarea>
                </div>
                <b-card no-body class="col-12 mb-1 p-0">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="'accordion-new'"  variant="info"  class="btn btn-primary">Design Steps</b-button>
                  </b-card-header>
                  <b-card-body class=" text-left"> 
                    <div v-for="(step, index) in firstSection.steps " :key="index" class="row">
                    <b-button block v-b-toggle="'accordion-new'"  variant="info"  class="btn btn-primary">Step {{index + 1}}</b-button>
                      <div class="form-group col-sm-6">
                        <label for="title">Title</label>
                        <input
                          class="form-control"
                          type="text"
                          v-model="step.title"
                          id="title"
                        />
                      </div>
                      <div class="form-group col-sm-6">
                        <label for="title_en">Title (EN)</label>
                        <input
                          class="form-control"
                          type="text"
                          v-model="step.title_en"
                          id="title_en"
                        />
                      </div>

                      <!-- Content/Description -->
                      <div class="form-group col-sm-6">
                        <label for="content">Description</label>
                        <textarea
                          class="form-control"
                          id="content"
                          cols="30"
                          rows="3"
                          v-model="step.content"
                          >
                        </textarea>
                      </div>

                      <div class="form-group col-sm-6">
                        <label for="content_en">Description (EN)</label>
                        <textarea
                          class="form-control"
                          id="content_en" 
                          cols="30"
                          rows="3"
                          v-model="step.content_en"
                          >
                        </textarea>
                      </div>

                    </div>
                  </b-card-body>
                </b-card>
                <!-- Button Text -->
                <div class="form-group col-sm-6">
                  <label for="btn_text">Button Text</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="firstSection.btn_text"
                    id="btn_text"
                    
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="btn_text_en">Button Text (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="firstSection.btn_text_en"
                    id="btn_text_en"
                    
                  />
                </div>

                <!-- URL -->
                <div class="form-group col-sm-6">
                  <label for="btn_url">Button URL<br><small class="text-muted">*Example: contact, about, customizations</small></label>
                  <div class="form-inline">
                    <!--
                    -- TODO: Website URL must be changed in case we need a new instance on a different domain
                    -->
                    <span class="mr-1">ithoob.com/</span>
                    <input
                      class="form-control"
                      type="text"
                      v-model="firstSection.btn_url"
                      id="btn_url"
                    />
                  </div>
                </div>

                <!-- Upload Image -->
                <div class="form-group col-sm-6">
                  <label for="img_upload">Upload Image<br><small class="text-muted">*1 : 0.54 (W : H) for banner image - Example: 1600x600</small></label>
                  <input
                    class="form-control"
                    type="file"
                    id="firstSection"
                    @change="uploadFile('firstSection')"
                  />
                </div>


                <!-- Image Preview -->
                <div class="img-preview col-12">
                  <img :src="firstSection.image">
                </div>
                <div>
                  <button
                      type="button"
                      class="btn btn-info float-right"
                      v-on:click="updateHomeSections('firstSection')"
                    >Confirm Changes</button>
                </div>
              </b-card-body>
          </b-card>
        </div>
        <div class="tab-pane fade" id="nav-banner-one" role="tabpanel" aria-labelledby="nav-banner-one-tab">
          <b-card no-body class="col-12 mb-1 p-0">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-new'"  variant="info"  class="btn btn-primary">Home Banner one Section</b-button>
            </b-card-header>
              <b-card-body class="row text-left"> 
                <!-- Title -->
                <div class="form-group col-sm-6">
                  <label for="title">Title</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="secondSection.title"
                    id="title"
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="title_en">Title (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="secondSection.title_en"
                    id="title_en"
                  />
                </div>

                <!-- Content/Description -->
                <div class="form-group col-sm-6">
                  <label for="content">Description</label>
                  <textarea
                    class="form-control"
                    id="content"
                    cols="30"
                    rows="3"
                    v-model="secondSection.content"
                    >
                  </textarea>
                </div>
                <div class="form-group col-sm-6">
                  <label for="content_en">Description (EN)</label>
                  <textarea
                    class="form-control"
                    id="content_en" 
                    cols="30"
                    rows="3"
                    v-model="secondSection.content_en"
                    >
                  </textarea>
                </div>

                <!-- Button Text -->
                <div class="form-group col-sm-6">
                  <label for="btn_text">Button Text</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="secondSection.btn_text"
                    id="btn_text"
                    
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="btn_text_en">Button Text (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="secondSection.btn_text_en"
                    id="btn_text_en"
                    
                  />
                </div>

                <!-- URL -->
                <div class="form-group col-sm-6">
                  <label for="btn_url">Button URL<br><small class="text-muted">*Example: contact, about, customizations</small></label>
                  <div class="form-inline">
                    <!--
                    -- TODO: Website URL must be changed in case we need a new instance on a different domain
                    -->
                    <span class="mr-1">ithoob.com/</span>
                    <input
                      class="form-control"
                      type="text"
                      v-model="secondSection.btn_url"
                      id="btn_url"
                    />
                  </div>
                </div>

                <!-- Upload Image -->
                <div class="form-group col-sm-6">
                  <label for="img_upload">Upload Image<br><small class="text-muted">*1 : 0.54 (W : H) for banner image - Example: 1600x600</small></label>
                  <input
                    class="form-control"
                    type="file"
                    id="secondSection"
                    @change="uploadFile('secondSection')"
                  />
                </div>


                <!-- Image Preview -->
                <div class="img-preview col-12">
                  <img :src="secondSection.image">
                </div>
                <div>
                  <button
                      type="button"
                      class="btn btn-info float-right"
                      v-on:click="updateHomeSections('secondSection')"
                    >Confirm Changes</button>
                </div>
              </b-card-body>
          </b-card>
        </div>
        <div class="tab-pane fade" id="nav-banner-two" role="tabpanel" aria-labelledby="nav-banner-two-tab">
          <b-card no-body class="col-12 mb-1 p-0">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-new'"  variant="info"  class="btn btn-primary">Home Banner Two Section</b-button>
            </b-card-header>
              <b-card-body class="row text-left"> 
                <!-- Title -->
                <div class="form-group col-sm-6">
                  <label for="title">Title</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="thirdSection.title"
                    id="title"
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="title_en">Title (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="thirdSection.title_en"
                    id="title_en"
                  />
                </div>

                <!-- Content/Description -->
                <div class="form-group col-sm-6">
                  <label for="content">Description</label>
                  <textarea
                    class="form-control"
                    id="content"
                    cols="30"
                    rows="3"
                    v-model="thirdSection.content"
                    >
                  </textarea>
                </div>
                <div class="form-group col-sm-6">
                  <label for="content_en">Description (EN)</label>
                  <textarea
                    class="form-control"
                    id="content_en" 
                    cols="30"
                    rows="3"
                    v-model="thirdSection.content_en"
                    >
                  </textarea>
                </div>

                <!-- Button Text -->
                <div class="form-group col-sm-6">
                  <label for="btn_text">Button Text</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="thirdSection.btn_text"
                    id="btn_text"
                    
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="btn_text_en">Button Text (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="thirdSection.btn_text_en"
                    id="btn_text_en"
                    
                  />
                </div>

                <!-- URL -->
                <div class="form-group col-sm-6">
                  <label for="btn_url">Button URL<br><small class="text-muted">*Example: contact, about, customizations</small></label>
                  <div class="form-inline">
                    <!--
                    -- TODO: Website URL must be changed in case we need a new instance on a different domain
                    -->
                    <span class="mr-1">ithoob.com/</span>
                    <input
                      class="form-control"
                      type="text"
                      v-model="thirdSection.btn_url"
                      id="btn_url"
                    />
                  </div>
                </div>

                <!-- Upload Image -->
                <div class="form-group col-sm-6">
                  <label for="img_upload">Upload Image<br><small class="text-muted">*1 : 0.54 (W : H) for banner image - Example: 1600x600</small></label>
                  <input
                    class="form-control"
                    type="file"
                    id="thirdSection"
                    @change="uploadFile('thirdSection')"
                  />
                </div>


                <!-- Image Preview -->
                <div class="img-preview col-12">
                  <img :src="thirdSection.image">
                </div>
                <div>
                  <button
                      type="button"
                      class="btn btn-info float-right"
                      v-on:click="updateHomeSections('thirdSection')"
                    >Confirm Changes</button>
                </div>
              </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans");
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

.media-body[data-v-67d21ddd] {
  text-align: left;
  padding: 15px;
}
.media img {
  border-radius: 15px;
}
.arrows {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  flex-direction: column;
  width: 60px;
  padding: 20px;
}
.arrows i {
  font-size: 1.6em;
}
.toolbar {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  right: 0;
  padding: 10px 50px;
  background: #fff;
  border-bottom: 1px solid #eee;
  z-index: 99;
}

h1 {
  margin-bottom: 0;
}

.card {
  transition: all 150ms ease-in-out;

  &:hover {
    background: #fafafa;
  }
}

.img-preview {
  max-height: 500px;
  text-align: center;

  img {
    width: auto;
    max-width: 100%;
    height: 100%;
  }
}

.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}

.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  margin-top: 50px;
  padding: 50px;
  width: 80%;
}

.spinner-wrapper {
  display: none;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 100%;
  top: 0;
  right: 0;
  background: rgba(230, 230, 230, 0.61);
  z-index: 99;
}
.spinner-wrapper.show {
  display: flex;
}
.spinner-wrapper.hide {
  display: none;
}

.spinner-border {
  width: 3.5rem;
  height: 3.5rem;
}

.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

/* The snackbar - position it at the bottom and in the middle of the screen */
.snackbar {
  position: fixed;
  bottom: -100px;
  left: 40%;
  z-index: 1;
  transition: all 300ms ease-in-out;
}

.snackbar.show {
  bottom: 30px;
  opacity: 1;
}
</style>

<script>
import axios from "axios";
import { getCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";
import "../../node_modules/bootstrap/js/src/tab.js";
const arrayMove = require("array-move");

export default {
  name: "banner",
  data() {
    return {
      sections: [],
      firstSection: { steps: [] },
      secondSection: {},
      thirdSection: {},
      fourthSection: {},
      newSlide: {
        image: "https://higuma.github.io/bootstrap-4-tutorial/img/slide-1.svg",
        type: "banner",
      },
      errors: [], // Form's errors
      serverMessage: "",
      formState: {
        loading: false,
        invalidShake: false,
      },
      image: {
        uploaded: null,
        newFileUpload: null,
        value: null,
      },
    };
  },
  watch: {},
  mounted() {
    this.getHomeSections();
  },
  methods: {
    handleUpClicked(index) {
      let result = arrayMove(this.sections, index, index - 1);
      this.sections = result;
    },
    handleDownClicked(index) {
      let result = arrayMove(this.sections, index, index + 1);
      this.sections = result;
    },
    updateHomeSections(target) {
      let updatedOrder = [];
      let section;
      let snackbar = document.getElementById("snackbar");
      if(target === "sectionsOrder"){
        this.sections.forEach((element, index) => {
          element.section_order = index + 1;
          updatedOrder.push(element);
        });
        section = updatedOrder;
      }else if(target === "firstSection"){
        section = this.firstSection;
      }else if(target === "secondSection"){
        section = this.secondSection;
      }else if(target === "thirdSection"){
        section = this.thirdSection;
      }
      
      return axios
        .post(`${herokuUrl}/dashboard/edit_home_sections_order`, {target , section}, {
          headers: {
            Authorization: getCookie("user"),
          },
        })
        .then(() => {
          this.formState.loading = false;

          this.serverMessage =
            "The sections order has been updated successfully";
          snackbar.className = "snackbar show alert alert-success";
          snackbar.classList.remove("alert-danger"); // If exist, it will be deleted
          snackbar.classList.add("show", "alert-success");
          setTimeout(function () {
            snackbar.className = snackbar.className.replace("show", "");
          }, 3000);

          // this.partiallyResetForm();
          // this.fetchAllplaces();
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;

            this.serverMessage =
              "There was a problem, and we couldn't update your Sections";
            snackbar.classList.remove("alert-success"); // If exist, it will be deleted
            snackbar.classList.add("show", "alert-danger");
            setTimeout(function () {
              snackbar.className = snackbar.className.replace("show", "");
            }, 3000);
          }
        });
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function () {
          this.formState.invalidShake = false;
        }.bind(this),
        1000
      );
    },
    checkNewForm() {
      // Reset errors
      this.errors = [];

      // Limits
      let titleMax = 35;
      let descMax = 75;
      let btnTextMax = 25;
      let index = this.data.slides.length + 1;
      if (this.newSlide.title) {
        if (this.newSlide.title.length > titleMax) {
          this.errors.push(
            `Slide #${index} Title must be ${titleMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Title is required`);
      }
      if (this.newSlide.title_en) {
        if (this.newSlide.title_en.length > titleMax) {
          this.errors.push(
            `Slide #${index} Title (EN) must be ${titleMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Title (EN) is required`);
      }

      // Content
      if (this.newSlide.content) {
        if (this.newSlide.content.length > descMax) {
          this.errors.push(
            `Slide #${index} Description must be ${descMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Description is required`);
      }
      if (this.newSlide.content_en) {
        if (this.newSlide.content_en.length > descMax) {
          this.errors.push(
            `Slide #${index} Description (EN) must be ${descMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Description (EN) is required`);
      }

      // Button
      if (this.newSlide.btn_text) {
        if (this.newSlide.btn_text.length > btnTextMax) {
          this.errors.push(
            `Slide #${index} Button Text must be ${btnTextMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index + 1} Button Text is required`);
      }
      if (this.newSlide.btn_text_en) {
        if (this.newSlide.btn_text_en.length > btnTextMax) {
          this.errors.push(
            `Slide #${index} Button Text (EN) must be ${btnTextMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Button Text (EN) is required`);
      }

      // URL
      if (!this.newSlide.btn_url) {
        this.errors.push(`Slide #${index} Button URL is required`);
      }

      // Image
      if (!this.newSlide.image) {
        this.errors.push(`Slide #${index} Image is required`);
      }
    },
    checkForm() {
      // Reset errors
      this.errors = [];

      // Limits
      let titleMax = 35;
      let descMax = 75;
      let btnTextMax = 25;

      // Loop over each slide given data, and check if they match the criteria or not
      this.data.slides.map((slide, index) => {
        if (slide.title) {
          if (slide.title.length > titleMax) {
            this.errors.push(
              `Slide #${index + 1} Title must be ${titleMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Title is required`);
        }
        if (slide.title_en) {
          if (slide.title_en.length > titleMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Title (EN) must be ${titleMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Title (EN) is required`);
        }

        // Content
        if (slide.content) {
          if (slide.content.length > descMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Description must be ${descMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Description is required`);
        }
        if (slide.content_en) {
          if (slide.content_en.length > descMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Description (EN) must be ${descMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Description (EN) is required`);
        }

        // Button
        if (slide.btn_text) {
          if (slide.btn_text.length > btnTextMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Button Text must be ${btnTextMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Button Text is required`);
        }
        if (slide.btn_text_en) {
          if (slide.btn_text_en.length > btnTextMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Button Text (EN) must be ${btnTextMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Button Text (EN) is required`);
        }

        // URL
        if (!slide.btn_url) {
          this.errors.push(`Slide #${index + 1} Button URL is required`);
        }

        // Image
        if (!slide.image) {
          this.errors.push(`Slide #${index + 1} Image is required`);
        }
      });
    },
    getHomeSections() {
      // Show Loader
      this.formState.loading = true;

      // Get Slides Data
      return axios
        .get(`${herokuUrl}/dashboard/home_sections_order`, {
          headers: {
            Authorization: getCookie("user"),
          },
        })
        .then((res) => {
          this.sections = res.data.sectionsOrder;
          this.firstSection = res.data.firstSection;
          this.secondSection = res.data.secondSection;
          this.thirdSection = res.data.thirdSection;
          this.fourthSection = res.data.fourthSection;
          // Stop the loader
          this.formState.loading = false;
          console.log(res.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Sections fetching failed, " + err.response.data.message);
            // console.log(err);
          }
        });
    },
    compress(elem, sizeW, sizeH, compressedFileObj) {
      const width = sizeW;
      const height = sizeH;
      const fileName = elem.files[0].name;
      const reader = new FileReader();
      // console.log(elem.files[0]);
      reader.readAsDataURL(elem.files[0]);
      return (reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        (img.onload = () => {
          const elem = document.createElement("canvas");
          elem.width = width;
          elem.height = height;
          const ctx = elem.getContext("2d");
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, width, height);
          ctx.canvas.toBlob(
            (blob) => {
              const file = new File([blob], fileName, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              compressedFileObj.flag = true;
              compressedFileObj.file = file;
            },
            "image/jpeg",
            1
          );
        }),
          (reader.onerror = (error) => {
            compressedFileObj.flag = "error";
            console.log(error);
          });
      });
    },
    /**
     * TODO: This function uploads the file directly to the server. Without confirming first.
     * It must upload the image after submitting the form.
     *
     * [WHY] User might try to upload multiple images for testing purposes, without submitting.
     * This will pump the server with too many unused images.
     */
    uploadFile(imgName) {
      console.log(imgName);
      if (
        !(
          document.getElementById(imgName).files[0] &&
          document.getElementById(imgName).files[0].name
        )
      )
        return;
      this.formState.loading = true;
      this.image.uploaded = false;
      let checkObj = { file: null, flag: false };
      let width = 1600;
      let height = 600;
      if(imgName === "firstSection"){
        width = 790;
        height = 900;
      }
      this.compress(document.getElementById(imgName), width, height, checkObj);
      // let file = document.getElementById("image").files[0];
      let fn = () => {
        if (checkObj.flag && checkObj.flag != "error") {
          this.image.newFileUpload = new FormData();
          this.image.newFileUpload.set("images", checkObj.file);
          axios
            .post(`${herokuUrl}/adminUpload`, this.image.newFileUpload, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: getCookie("user"),
              },
            })
            .then((res) => {
              if (res.data.status) {
                this.image.uploaded = true;
                this.image.value = res.data.sources[0];
                this.formState.loading = false;
                // Add the uploaded image path to its slide object
                if (imgName == "firstSection") {
                  this.firstSection.image = res.data.sources[0];
                } else if (imgName == "secondSection") {
                  this.secondSection.image = res.data.sources[0];
                }else if (imgName == "secondSection") {
                  this.thirdSection.image = res.data.sources[0];
                }
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " + res.message
                );
                this.formState.loading = false;
              }
            })
            .catch((err) => {
              if (err.response.status == 401) {
                logOut();
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " +
                    err.response.data.message
                );
                this.formState.loading = false;
              }
            });
        } else if (checkObj.flag == "error") {
          alert("Compression Error");
          this.formState.loading = false;
        } else {
          setTimeout(fn, 200);
        }
      };
      fn();
    },
    createNewBanner() {
      // Check if form is validated
      this.checkNewForm();

      // If there's any error, shake the form. If not, start the update process
      if (!this.errors.length) {
        let snackbar = document.getElementById("snackbar");
        this.formState.loading = true;

        return axios
          .post(`${herokuUrl}/dashboard/create-banner-slide`, this.newSlide, {
            headers: {
              Authorization: getCookie("user"),
            },
          })
          .then(() => {
            this.formState.loading = false;
            this.newSlide = {
              image:
                "https://higuma.github.io/bootstrap-4-tutorial/img/slide-1.svg",
              type: "banner",
            };
            this.serverMessage = "This section has been updated successfully";
            snackbar.className = "snackbar show alert alert-success";
            snackbar.classList.remove("alert-danger"); // If exist, it will be deleted
            snackbar.classList.add("show", "alert-success");
            setTimeout(function () {
              snackbar.className = snackbar.className.replace("show", "");
            }, 3000);

            // this.partiallyResetForm();
            this.fetchBannerData();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;

              this.serverMessage =
                "There was a problem, and we create your banner";
              snackbar.classList.remove("alert-success"); // If exist, it will be deleted
              snackbar.classList.add("show", "alert-danger");
              setTimeout(function () {
                snackbar.className = snackbar.className.replace("show", "");
              }, 3000);
            }
          });
      } else {
        this.shakeForm();
      }
    },
    deleteBanner(id) {
      // If there's any error, shake the form. If not, start the update process
      if (id) {
        let snackbar = document.getElementById("snackbar");
        this.formState.loading = true;

        return axios
          .post(
            `${herokuUrl}/dashboard/delete-banner-slide`,
            { id: id },
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            this.formState.loading = false;

            this.serverMessage = "This section has been deleted successfully";
            snackbar.className = "snackbar show alert alert-success";
            snackbar.classList.remove("alert-danger"); // If exist, it will be deleted
            snackbar.classList.add("show", "alert-success");
            setTimeout(function () {
              snackbar.className = snackbar.className.replace("show", "");
            }, 3000);

            // this.partiallyResetForm();
            this.fetchBannerData();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;

              this.serverMessage =
                "There was a problem, while deleting your banner";
              snackbar.classList.remove("alert-success"); // If exist, it will be deleted
              snackbar.classList.add("show", "alert-danger");
              setTimeout(function () {
                snackbar.className = snackbar.className.replace("show", "");
              }, 3000);
            }
          });
      } else {
        this.shakeForm();
      }
    },
    updateBanner() {
      // Check if form is validated
      this.checkForm();

      // If there's any error, shake the form. If not, start the update process
      if (!this.errors.length) {
        let snackbar = document.getElementById("snackbar");
        this.formState.loading = true;

        return axios
          .post(
            `${herokuUrl}/dashboard/update-banner-slides`,
            this.data.slides,
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            this.formState.loading = false;

            this.serverMessage = "This section has been updated successfully";
            snackbar.className = "snackbar show alert alert-success";
            snackbar.classList.remove("alert-danger"); // If exist, it will be deleted
            snackbar.classList.add("show", "alert-success");
            setTimeout(function () {
              snackbar.className = snackbar.className.replace("show", "");
            }, 3000);

            // this.partiallyResetForm();
            // this.fetchAllplaces();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;

              this.serverMessage =
                "There was a problem, and we couldn't update your banner";
              snackbar.classList.remove("alert-success"); // If exist, it will be deleted
              snackbar.classList.add("show", "alert-danger");
              setTimeout(function () {
                snackbar.className = snackbar.className.replace("show", "");
              }, 3000);
            }
          });
      } else {
        this.shakeForm();
      }
    },
  },
  components: {
    appNavigation: Navigation,
  },
};
</script>
